<template>
  <div>
    <section class="login-container boxed-login" @keyup.enter="signin">
      <div class="container">
        <div class="col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4">
          <div class="login-form-container">
            <div class="j-forms" id="forms-login" novalidate="novalidate">
              <div class="login-form-header">
                <div class="logo">
                  <img class="logo-pic" src="../../assets/img/logo3.png" alt="logo">
                </div>
              </div>
              <div class="login-form-content">
                <!-- start login -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="login">
                      <i class="zmdi zmdi-account"></i>
                    </label>
                    <input class="form-control login-frm-input" type="text" id="login" name="email" placeholder="Email" v-model="email" v-validate="'required|email'">
                    <i v-show="errors.has('email')" class="fa fa-warning"></i>
                    <span v-show="errors.has('email')" class="help is-danger">請輸入正確的Email</span>
                  </div>
                </div>
                <!-- end login -->
                <!-- start password -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="password">
                      <i class="zmdi zmdi-key"></i>
                    </label>
                    <input class="form-control login-frm-input" type="password" id="password" name="password" placeholder="密碼" v-model="password" v-on:keyup.enter="signin" v-validate="'required'">
                    <i v-show="errors.has('password')" class="fa fa-warning"></i>
                    <span v-show="errors.has('password')" class="help is-danger">請輸入密碼</span>
                  </div>
                </div>
                <!-- end password -->
                <!-- start response from server -->
                <div class="response"></div>
                <!-- end response from server -->
              </div>
              <div class="login-form-footer" style="padding-top:0px;">
                <button class="btn-block btn btn-info" v-on:click="signin">登入</button>
              </div>
            </div>
            <hr>
            <div class="login-form-footer" style="padding-top:0px;margin-bottom:0px;">
              <router-link class="btn-block btn btn-success" to="signup">
                <i class="fas fa-user-plus"></i>&nbsp;&nbsp;馬上註冊，免費使用
              </router-link>
            </div>
            <div class="pointer">
                <a class="gary" @click="resendValidateMailModal = true">點此重發驗證信</a><span class="gary">&nbsp;&nbsp;|&nbsp;&nbsp;</span><a  @click="forgotPasswordModal = true" class="gary">忘記密碼？</a>
            </div>
          </div>
        </div>
      </div>
      <!--Footer Start Here -->
      <footer class="login-page-footer">
      </footer>
      <!--Footer End Here -->
    </section>
    <!-- modal template start-->
    <div v-if="resendValidateMailModal" @keyup.esc="resendValidateMailModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="resendValidateMailModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">重發驗證信</h3>
              </div>
            </div>
            <div class="modal-body">
              <div name="body">
                <p>請輸入你之前註冊的Email，Flowneat將會重新寄送驗證信到您的信箱
                  <br><small>（*請注意看看是否寄到垃圾收件夾，若真的在收件夾，建議您將Flowneat設定為安全聯絡人，以免錯過重要的提示信件）</small></p>
                <div class="input login-input">
                  <input class="form-control login-frm-input" type="text" placeholder="請輸入你的Email" @keyup.enter="resendValidateMail()" v-model="resend_email">
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-info" @click="resendValidateMail()">
                  重發驗證信
                </button>
                <button class="btn btn-default" @click="resendValidateMailModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="forgotPasswordModal" @keyup.esc="forgotPasswordModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="forgotPasswordModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">忘記密碼？</h3>
              </div>
            </div>
            <div class="modal-body">
              <div name="body">
                <p>請輸入你之前註冊的Email，Flowneat將會重新寄送密碼重設信函到您的信箱
                  <br><small>（*請注意看看是否寄到垃圾收件夾，若真的在收件夾，建議您將Flowneat設定為安全聯絡人，以免錯過重要的提示信件）</small></p>
                <div class="input login-input">
                  <input class="form-control login-frm-input" type="text" placeholder="請輸入你的Email" v-model="resend_email">
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-info" @click="resendForgotPasswordMail()">
                  重設密碼
                </button>
                <button class="btn btn-default" @click="forgotPasswordModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'login',
  components: { Simplert },
  data() {
    return {
      email: '',
      resend_email: '',
      resendValidateMailModal: false,
      forgotPasswordModal: false,
      password: '',
      refs: this.$refs
    }
  },
  beforeCreate: function() {
    document.body.className = 'login';
  },
  created() {
    this.checkLogin();
  },
  methods: {
    signin() {
      if (this.email != '' && this.password != '') {
        this.validateBeforeSubmit()
      } else {
        var obj = {
          isShown: true,
          title: '登入失敗',
          message: '請輸入帳號密碼',
          type: 'error',
          customCloseBtnText: '關閉'
        }
        this.refs.simplert.openSimplert(obj);
      }
    },
    toSignin() {
      const vm = this;
      this.axios.post('sessions', {
        user: {
          email: this.email,
          password: this.password,
        }
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          setCookie("auth_token", response['data']['auth_token'], 7)
          setCookie("aside_bar", true, 7)
          vm.axios.defaults.headers.common['Auth-Token'] = response['data']['auth_token']
          vm.$toastr.s('登入成功！開始進行工作吧！')
          vm.$router.push('/dashboard')
        } else if (response['data']['status'] == '1') {
          var obj = {
            isShown: true,
            title: '此帳號尚未註冊',
            type: 'info',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        } else if (response['data']['status'] == '2') {
          var obj2 = {
            isShown: true,
            title: '帳號或密碼錯誤',
            type: 'info',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj2);
        } else if (response['data']['status'] == '3') {
          var obj2 = {
            isShown: true,
            title: '此帳號尚未通過驗證',
            message: '這個信箱尚未通過驗證，請檢查信箱點擊驗證連結，或點下列按鈕重發驗證信',
            type: 'info',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj2);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    resendValidateMail(){
      this.resendValidateMailModal=false
      const vm = this;
      this.axios.put('sessions', {
        user: {
          email: this.resend_email,
        }
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          var obj = {
            isShown: true,
            title: '重發成功',
            message: '已重發驗證信到'+vm.resend_email+'，請到該信箱，點擊驗證連結進行驗證。',
            type: 'success',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        } else if (response['data']['status'] == 'fail') {
          var obj = {
            isShown: true,
            title: '重發失敗',
            message: response['data']['msg'],
            type: 'warning',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        } else{
          var obj = {
            isShown: true,
            title: '重發失敗',
            message: response['data']['msg'],
            type: 'info',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    resendForgotPasswordMail(){
      this.forgotPasswordModal=false
      const vm = this;
      this.axios.post('sessions/apply_reset_password', {
        user: {
          email: this.resend_email,
        }
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          var obj = {
            isShown: true,
            title: '發送成功',
            message: '已發送密碼重設信件到'+vm.resend_email+'，請到該信箱，點擊重設連結，重新設定密碼。',
            type: 'success',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        } else if (response['data']['status'] == '1') {
          var obj = {
            isShown: true,
            title: '發送失敗',
            message: response['data']['message'],
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        } else if (response['data']['status'] == '2') {
          var obj2 = {
            isShown: true,
            title: '此帳號尚未通過驗證',
            message: '這個信箱尚未通過驗證，請檢查信箱點擊驗證連結，重發驗證信',
            type: 'info',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj2);
        } else if (response['data']['status'] == 'fail') {
          var obj2 = {
            isShown: true,
            title: '發送失敗',
            message: response['data']['msg'],
            type: 'info',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj2);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.toSignin();
        } else {
          var obj = {
            isShown: true,
            title: 'Email格式錯誤',
            message: '請輸入正確Email格式',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          this.refs.simplert.openSimplert(obj);
        }
      });
    },
    // if user have already login, then deny him go login page
    checkLogin() {
      if (getCookie('auth_token')) {
        this.$router.push('/dashboard');
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// Login.vue?9add0d5c